export type AppTheme = 'default' | 'light';

const THEME_KEY = 'appTheme';

export const getStoredTheme = (): AppTheme => {
  if (typeof window === 'undefined') return 'default';
  const t = localStorage.getItem(THEME_KEY) as AppTheme | null;
  return t === 'light' ? 'light' : 'default';
};

export const applyTheme = (theme: AppTheme) => {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;

  if (theme === 'light') {
    root.classList.remove('dark');
    root.setAttribute('data-theme', 'light');
  } else {
    root.removeAttribute('data-theme');
  }
};

export const setTheme = (theme: AppTheme) => {
  localStorage.setItem(THEME_KEY, theme);
  applyTheme(theme);
};
